import { BillingSchedule } from "api/entities/BillingSchedule";

export interface Addon {
  id: string;
  name: string;
  description: string;
  addonBillingType: AddonBillingType;
  addonAllowedTypes: AddonAllowedType[];
  price: number;
  netCommissionableRevenue: number;
  contractLengthDictionary?: { [key: number]: number };
  customizableStartDateAndContractLength: boolean;
  onlySpecialPricing: boolean;
  specialPricingList: SpecialPricing[];
}

export interface AddonDetails {
  id: string;
  referenceId: string;
  name: string;
  description: string;
  addonBillingType: AddonBillingType;
  addonAllowedTypes: AddonAllowedType[];
  price: number;
  netCommissionableRevenue: number;
  schedule?: BillingSchedule;
  startDate?: string;
  contractLength?: number;
  contractLengthDictionary?: { [key: number]: number };
  customizableStartDateAndContractLength: boolean;
  onlySpecialPricing: boolean;
  specialPricingList: SpecialPricing[];
  additionalAddonDetailsList?: AddonDetails[];
}

export enum AddonBillingType {
  OneTime = "OneTime",
  ParentRecurring = "ParentRecurring",
  IndividualRecurring = "IndividualRecurring",
  IndividualIncentive = "IndividualIncentive",
}

export enum AddonAllowedType {
  Plan = "Plan",
  Addon = "Addon",
}

export interface SpecialPricing {
  productGroupId: string;
  addonId: string;
  price: number;
  netCommissionableRevenue: number;
}

export enum AddonStatus {
  Inactive = "Inactive",
  PendingPayment = "PendingPayment",
  PaymentFailed = "PaymentFailed",
  Active = "Active",
  Ending = "Ending",
  Ended = "Ended",
}
